// Přílohy (docs/SPEC.md 2.5 a část 5): fotky zakázek s tagy a souhlasem, soubory jen přes podepsané URL.
import { z } from 'zod'

export const ATTACHMENT_ENTITY_TYPES = ['job', 'client', 'interaction', 'org'] as const
export const ATTACHMENT_KIND_VALUES = ['photo', 'video', 'document'] as const
export const ATTACHMENT_TAG_VALUES = ['before', 'after', 'team', 'other'] as const

export const MAX_ATTACHMENT_BYTES = 25 * 1024 * 1024
export const ALLOWED_ATTACHMENT_MIMES = [
  'image/jpeg',
  'image/png',
  'image/webp',
  'image/heic',
  'video/mp4',
  'application/pdf',
] as const

export const signUploadSchema = z.object({
  entityType: z.enum(ATTACHMENT_ENTITY_TYPES),
  entityId: z.string().uuid(),
  name: z.string().trim().min(1).max(200),
  mime: z.enum(ALLOWED_ATTACHMENT_MIMES),
  size: z.number().int().min(1).max(MAX_ATTACHMENT_BYTES),
})
export type SignUploadInput = z.infer<typeof signUploadSchema>

/** Odpověď POST /v1/attachments/sign-upload: kam a jak soubor nahrát. */
export interface SignedUpload {
  key: string
  uploadUrl: string
  method: 'PUT'
  headers: Record<string, string>
  expiresAt: string
}

export const createAttachmentSchema = z.object({
  entityType: z.enum(ATTACHMENT_ENTITY_TYPES),
  entityId: z.string().uuid(),
  key: z.string().min(1).max(500),
  name: z.string().trim().min(1).max(200),
  mime: z.enum(ALLOWED_ATTACHMENT_MIMES),
  size: z.number().int().min(1).max(MAX_ATTACHMENT_BYTES),
  kind: z.enum(ATTACHMENT_KIND_VALUES).default('photo'),
  tags: z.array(z.enum(ATTACHMENT_TAG_VALUES)).default([]),
  marketingConsent: z.boolean().default(false),
  takenAt: z.string().datetime({ offset: true }).optional().nullable(),
})
export type CreateAttachmentInput = z.infer<typeof createAttachmentSchema>

export interface Attachment {
  id: string
  entityType: string
  entityId: string
  name: string
  mime: string
  size: number
  kind: 'photo' | 'video' | 'document'
  tags: string[]
  marketingConsent: boolean
  takenAt: string | null
  createdAt: string
  /** Podepsaná URL ke stažení s omezenou platností. */
  url: string
}
